/**
 * Maps dialect codes to base ISO 639-1 language codes.
 *
 * Campaigns and org configs use dialect codes (e.g. 'en_us', 'en_gb', 'pt_br')
 * for LLM dialect support. Templates use base language codes
 * (e.g. 'en', 'de', 'pt'). All English dialects map to 'en',
 * and all Portuguese dialects map to 'pt'.
 */
export const toBaseLanguageCode = (lang: string): string => {
  if (lang.startsWith('en_')) return 'en';
  if (lang.startsWith('pt_')) return 'pt';
  return lang;
};
